/* eslint-disable @typescript-eslint/no-explicit-any */
import './style.scss';

import React from 'react';
import {
  BuildersComponentsTrackingProvider,
  Flex,
  Link,
  Title
} from '@gjensidige/builders-components';
import { TrackingProvider } from '@gjensidige/core-analytics';

import { mapAPIToLegalLinks } from './mapper';
import { DocumentLinksProps } from './types';

export function DocumentLinks(props: DocumentLinksProps) {
  const legalLinks = mapAPIToLegalLinks(props);
  const containerSpan = props.containerSpan || 8;
  const containerOffset = props.containerOffset || 2;

  const openDocument = async (document: any) => {
    const url =
      window.location.origin +
      '/product-documents/documents?documentId=' +
      document.docId;
    window.open(url, '_blank');
  };

  const renderLinks = () => {
    return !props.isGridViewEnabled ? (
      <div className="links-container">
        <Title className="links-title" as="h2" size="5">
          {props.linkTitle}
        </Title>
        <div className="link-items">
          {legalLinks.map((link) => (
            <div className="link-item" key={link.linkText}>
              <Link
                target={`${props.openInNewWindow ? '_blank' : '_self'}`}
                onClick={() => openDocument(link)}
                className="link-text"
                key={link.linkText}
                tabIndex={0}
              >
                {link.linkText}
              </Link>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <div className="link-wrapper">
        <Flex direction="column">
          <div>
            <Title className="links-title" as="h2" size="5">
              {props.linkTitle}
            </Title>
          </div>
          <Flex layout={{ xs: 1, sm: 1, md: 1, lg: 2 }} className="link-item">
            {legalLinks.map((link) => (
              <Link
                target={`${props.openInNewWindow ? '_blank' : '_self'}`}
                onClick={() => openDocument(link)}
                className="link-text"
                key={link.linkText}
                tabIndex={0}
              >
                {link.linkText}
              </Link>
            ))}
          </Flex>
        </Flex>
      </div>
    );
  };
  return props.trackingObject && props.trackingObject?.options ? (
    <BuildersComponentsTrackingProvider options={props.trackingObject?.options}>
      <TrackingProvider options={props.trackingObject?.options}>
        {renderLinks()}
      </TrackingProvider>
    </BuildersComponentsTrackingProvider>
  ) : (
    renderLinks()
  );
}
